import React, { useEffect, useState } from 'react';
import { VertRadio, VertTypography } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Product/RelatedProductsCardStyles.less';
import { useSelector } from 'react-redux';

// API
import * as availabilityCloudLoyaltyService from '../../../Services/Apis/Availability/index';

const RelatedProductsCard = ({
    item,
    checked,
    showProductFeatures,
    setChecked,
}) => {

    const Oidc = useSelector(({ oidc: data }) => data);

    const [price, setPrice] = useState(null);
    const [notAvailable, setNotAvailable] = useState(true);

    const handleProductDetail = (sku) => {
        if (notAvailable) return;
        showProductFeatures(sku);
    }

    const handleGiftSelection = () => {
        setChecked({ ...item });
    }

    useEffect(() => {
        availabilityCloudLoyaltyService.getAvailability(
            Oidc.user,
            item.marketplaceSku,
            item.sku,
            item.vendor.integrationId).then(e => {                
                if (e === null) return;
                const { available, price } = e.data[0];
                if (available) {
                    setPrice(price);
                    setNotAvailable(false);
                }
                else {
                    setNotAvailable(true);
                }
            }).catch(error => {
                setNotAvailable(true);
            })
    }, []);

    return (
        <>
            <div
                className={
                    `related-product-container 
            ${!!checked ? ' gift-checked' : ''}
            `}
            >
                <VertRadio disabled={notAvailable} checked={checked} onClick={handleGiftSelection} className='gift-radio' />

                <div className='principal-content'>
                    <div className='carousel-container'>
                        <div className='carousel-item'>
                            <img className={`carousel-image ${notAvailable ? 'related-product-unavailable-image' : ''}`} src={item.imageUrl} />
                        </div>
                    </div>
                    <div
                        className={`data-content ${notAvailable ? 'related-product-unavailable' : ''}`}
                    >
                        <VertTypography.Paragraph strong>Fornecedor:</VertTypography.Paragraph>
                        <VertTypography.Paragraph
                            className='content-title'
                            strong>
                            {item.vendor.name}
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph
                            className='show-more-link'
                            onClick={() => handleProductDetail(item.sku)}
                        >
                            Mostrar detalhes
                        </VertTypography.Paragraph>

                    </div>

                </div>
                <div className="divider" />

                {
                    notAvailable ?
                        <>
                            <div className='price-content'>
                                <VertTypography.Text className='related-product-unavailable'>Produto indisponível</VertTypography.Text>
                            </div>
                        </>
                        :
                        <>
                            {
                                item.type != 3 ? (
                                    <div className='price-content'>
                                        <VertTypography.Paragraph strong>Resgate por</VertTypography.Paragraph>
                                        <VertTypography.Paragraph strong>{price} pontos</VertTypography.Paragraph>
                                    </div>
                                ) : (
                                    <div className='price-content'>
                                        <VertTypography.Paragraph strong>Solicite uma cotação</VertTypography.Paragraph>
                                    </div>
                                )
                            }
                        </>
                }

            </div>
        </>
    );
}

export default RelatedProductsCard;